import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConnectionService } from '../../../../services/connection/connection.service';
import { ShopSettingsService } from '../../../general/services/shop-settings.service';
import { ScanCard } from '../../../vu/models/scan-card';
import { TouchTileService } from '../../../vu/services/touch-tile.service';
import { VuCommunicationService } from '../../../vu/services/vu-communication.service';


@Component({
  selector: 'app-access-control-popup',
  templateUrl: './access-control-popup.component.html',
  styleUrls: ['./access-control-popup.component.css']
})
export class AccessControlPopupComponent implements OnInit, OnDestroy {
  public title = 'Staff RFID card is required';
  public message = 'Please scan your card!';

  private _isStaffCard = false;
  private _scanCardSubscription: Subscription;
  private _checkStuffBarcodeSubscription: Subscription;
  private _validationInProgress = false;

  constructor(
    public dialogRef: MatDialogRef<AccessControlPopupComponent>,
    private _vuCommunicationService: VuCommunicationService,
    private _connectionService: ConnectionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public shopSettingsService: ShopSettingsService,
    private _renderer: Renderer2,
    private _ref: ElementRef,
    private touchTileService: TouchTileService,
  ) { }

  ngOnInit() {
    if (this.shopSettingsService.isVUMode) {
      this._renderer.addClass(this._ref.nativeElement, 'vu-mode');
    }
    this._scanStaffCard();
  }

  private _scanStaffCard(): void {
    this.touchTileService.rfidCardLedEnable(true);
    this._scanCardSubscription = this._vuCommunicationService.scanCardCodeEvent
      .subscribe((code: ScanCard) => {
        if (!code || !code.cardID) {
          return;
        }
        if (!this._validationInProgress) {
          this._validationInProgress = true;
          this.message = 'Please Wait!';
          this._checkStaffCardByApi(code.cardID);
        }
      });
  }

  private _checkStaffCardByApi(code: string): void {
    this._checkStuffBarcodeSubscription = this._connectionService
      .sendGetRequest(`/api/ticket/is_staff/${code}`)
      .subscribe(
        (value: ArrayBuffer) => {
          this._isStaffCard = true;
          this.closeClick();
        },
        error => {
          this._isStaffCard = false;
          this.message = 'The card is not valid. Please scan another card!';
          this._validationInProgress = false;
        }
      );
  }

  ngOnDestroy() {
    this._validationInProgress = false;
    this.touchTileService.rfidCardLedEnable(false);
    if (this._scanCardSubscription) {
      this._scanCardSubscription.unsubscribe();
    }
    if (this._checkStuffBarcodeSubscription) {
      this._checkStuffBarcodeSubscription.unsubscribe();
    }
  }

  get isStaffCard(): boolean {
    return this._isStaffCard;
  }

  closeClick(): void {
    this.dialogRef.close();
  }

}
